import { Component, OnInit, Output, ElementRef } from '@angular/core';

import { ActivatedRoute } from '@angular/router'
import { NavigateService } from '../../service/navigate.service';
import { HomeService } from "../../service/home.service";

import { Location } from '@angular/common';

declare var $: any;

@Component({
    selector: 'app-vote-detail',
    templateUrl: './vote-detail.component.html',
    styleUrls: ['./vote-detail.component.styl']
})

export class VoteDetailComponent implements OnInit {
    public videoDom: any
    public videoPlay = false
    data: any = {};
    modal = {
        title: 'CHINAICAC MEMBER SIGN IN',
        isSigninShow: false,
        closeShow: false,
    };
    isLogin: boolean;

    constructor(private Location: Location, private route: ActivatedRoute, private el: ElementRef, private homeService: HomeService) { }

    ngOnInit() {
        this.videoDom = this.el.nativeElement.querySelector("video");

        const id = this.route.snapshot.queryParams.candidateId
        this.getElectCandidateDeatil(id)
        window.scrollTo(0, 0)

        // 播放结束状态
        this.videoDom.addEventListener('ended', () => {
            console.log('ended')
            this.videoPlay = false;
        })
        // 播放结束状态
        this.videoDom.addEventListener('pause', () => {
            console.log('pause')
            this.videoPlay = false;
        })
        this.videoDom.addEventListener('play', () => {
            console.log('play')
            this.videoPlay = true;
        })
    }

    playPauseHandle() { // 播放暂停
        //paused 返回的是视频是否是暂停状态,返回的是一个布尔值
        if (this.videoDom.paused) {
            this.videoPlay = true;
            this.videoDom.play();
        } else {
            this.videoDom.pause();
        }
    }
    getElectCandidateDeatil(candidateId){
        this.homeService.getCandidateDeatil(candidateId).subscribe(res=>{
            console.log(res)
            if (res.ok) {
                this.data = res.data
            }
        })
    }

    goBack(){
        this.Location.back()
    }
    
}


// WEBPACK FOOTER //
// /Users/apple/Documents/object/chinaicac-portal/src/app/vote/vote-detail/vote-detail.component.ts